
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>«Keine relevanten Veränderungen»</h4>
    <p>
Nach dem schweren Übergriff in der Baubaracke spricht das Solothurner Obergericht William W. schuldig wegen Vergewaltigung und sexuellen Handlungen mit einem Kind. Es verhängt eine stationäre Massnahme, auch kleine Verwahrung genannt. Diese ist für psychisch kranke Personen vorgesehen. Sie sollen hinter Gittern so lange in Therapie gehen, bis sie keine Gefahr mehr für die Gesellschaft darstellen. 
Nur funktioniert das bei W. nicht. Eine Therapie kann nur erfolgreich sein, wenn sich ein Täter öffnet. William W. tut das Gegenteil. Konsequent bestreitet der Mittdreissiger seine pädophile Neigung und verweigert jegliche Behandlung. Verschiedene Spezialisten hätten «keine relevanten Veränderungen» erzielen können, schreibt ein Gutachter 2015, man drehe sich «seit Jahren im Kreis».
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;